module.exports = __webpack_public_path__ + "static/media/icon-bubble-chart.2e59671b.svg";